import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface Props {
  text?: string | null;
  lines?: number;
  placeholder?: string;
  className?: string;
}

const Wrapper = styled.div``;

const Clamped = styled.div<{ lines: number; expanded: boolean }>`
  font-size: 14px;
  font-weight: 400;
  text-align: justify;
  ${(p) =>
    !p.expanded
      ? `display: -webkit-box; -webkit-line-clamp: ${p.lines}; -webkit-box-orient: vertical; overflow: hidden;`
      : ''}
`;

const Toggle = styled.div`
  color: #0b63d6;
  cursor: pointer;
  margin-top: 6px;
  font-size: 12px;
`;

const ExpandableText: FC<Props> = ({
  text,
  lines = 2,
  placeholder = 'N/A',
  className,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return setIsOverflowing(false);

    // ensure styles applied
    const t = setTimeout(() => {
      // Add a small tolerance (2px) to account for rounding differences
      setIsOverflowing(el.scrollHeight > el.clientHeight + 2);
    }, 0);

    return () => clearTimeout(t);
  }, [text, lines]);

  if (!text) return <>{placeholder}</>;

  return (
    <Wrapper className={className}>
      <Clamped ref={ref} lines={lines} expanded={expanded}>
        {text}
      </Clamped>
      {isOverflowing && (
        <Toggle onClick={() => setExpanded((v) => !v)}>
          {expanded ? 'Show less' : 'more'}
        </Toggle>
      )}
    </Wrapper>
  );
};

export default ExpandableText;
